module.exports = __webpack_public_path__ + "img/001-039.a88c8d84.png";